var map = {
	"./new_h2_default.json": [
		12635,
		2635
	],
	"./new_h2_default_eur.json": [
		5767,
		5767
	],
	"./new_h2_default_gbp.json": [
		96709,
		6709
	],
	"./new_h2_french.json": [
		48867,
		8867
	],
	"./new_h2_german.json": [
		46206,
		6206
	],
	"./new_h2_portuguese.json": [
		70655,
		655
	],
	"./new_h2_reading.json": [
		52342,
		486
	],
	"./new_h2_spanish.json": [
		22403,
		2403
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6577;
module.exports = webpackAsyncContext;